import LayoutPage from '@/components(new)/layout/LayoutBases/LayoutCentral/LayoutCentral.vue'
import LayoutPageAnalise from '@/components(new)/layout/LayoutBases/LayoutAnalise/LayoutAnalise.vue'
import listagemCadastros from '@/App/(authenticated)/modulos/cadastro/listagem-cadastros/listagem-cadastros.vue'
import listagemFinalizados from '@/App/(authenticated)/modulos/cadastro/listagem-finalizados/listagem-finalizados.vue'
import menuOptions from '@/libs/constants/painel/cadastro/menu.js'
import { items } from './routes'

const cadastro = [
  {
    path: '/cadastro/listagem',
    component: LayoutPageAnalise,
    props: {
      menuOptions: menuOptions
    },
    children: [
      {
        path: 'praticas',
        name: 'listagem/praticas',
        component: listagemCadastros,
        meta: {
          routeGroup: 'listagem/praticas'
        }
      },
      {
        path: 'finalizados',
        name: 'listagem/finalizados',
        component: listagemFinalizados,
        meta: {
          routeGroup: 'listagem/finalizados'
        }
      }
    ]
  },
  {
    path: '/cadastro',
    name: 'cadastro',
    component: LayoutPage,
    redirect: '/cadastro/listagem/praticas',
    children: [...items]
  }
]

export default cadastro



// WEBPACK FOOTER //
// ./src/router/cadastro/index.js